import React, { useEffect } from 'react';
import { useLoading } from '../../context/LoadingContext';
import { Container, TopBanner, LogoContainer, MenuIconContainer } from './styles';
import logo from '../../assets/logo.svg';
import MenuIcon from '../Icons/MenuIcon';
import CloseMenuIcon from '../Icons/CloseMenuIcon';
import LoadingIndicator from '../LoadingIndicator';
import { setupInterceptors } from '../../config/api';

const Layout = ({
  children,
  noLoadingIndicator,
  isChatbotPage,
  isMenuOpen,
  toggleMenu,
}) => {
  const { isLoading, setLoading } = useLoading();

  useEffect(() => {
    setupInterceptors(setLoading);
  }, [setLoading]);

  if (noLoadingIndicator) {
    return (
      <>
        <TopBanner>
          <LogoContainer>
            <img src={logo} alt='Logo' width={150} height={50} />
          </LogoContainer>
          {isChatbotPage && (
            <MenuIconContainer onClick={toggleMenu}>
                {isMenuOpen ? <CloseMenuIcon /> : <MenuIcon />}
            </MenuIconContainer>
          )}
        </TopBanner>
        <Container>{children}</Container>
      </>
    );
  }

  return (
    <>
      {isLoading && <LoadingIndicator />}
      <TopBanner>
        <LogoContainer>
          <img src={logo} alt='Logo' width={150} height={50} />
        </LogoContainer>
        {isChatbotPage && (
          <MenuIconContainer>
            <button onClick={toggleMenu}>
              {isMenuOpen ? <CloseMenuIcon /> : <MenuIcon />}
            </button>
          </MenuIconContainer>
        )}
      </TopBanner>
      <Container>{children}</Container>
    </>
  );
};

export default Layout;
